import script from "./DocItemMemo.vue?vue&type=script&setup=true&lang=js"
export * from "./DocItemMemo.vue?vue&type=script&setup=true&lang=js"

import "./DocItemMemo.vue?vue&type=style&index=0&id=9d1bced4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d1bced4"]])

export default __exports__